import React, { Fragment, useState } from "react";

import "./style.scss";
import { Tooltip } from "reactstrap";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";

/**
 * APP PRIMARY ICON CONTAINER
 * @param {Object} props
 * @param {string} props.id
 * @param {Element} props.icon
 * @param {Function} props.onClick
 * @param {String} props.className
 * @returns JSX.ELEMENT => ICON
 */
const AppIcon = React.memo((props) => {
  const iconClasses = `app-icon ${props.className}`;

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  let customProps = {};
  if (props.id) customProps = { ...customProps, id: props.id };
  if (props?.iconColor)
    customProps = { ...customProps, style: { color: props.iconColor } };
  return (
    <Fragment>
      <figure onClick={props.onClick} className={iconClasses} {...customProps}>
        {props.icon}
      </figure>

      {props?.tooltip && (
        <Tooltip
          toggle={toggle}
          isOpen={tooltipOpen}
          target={props?.id}
          placement={props?.tooltipPlacement || "right"}
        >
          <CustomFormattedMessage
            id={props?.label}
            defaultMessage={props?.label}
          />
        </Tooltip>
      )}
    </Fragment>
  );
});

export default AppIcon;
